import DialogContent from '@mui/material/DialogContent';
import Skeleton from '@mui/material/Skeleton';
import './bulkSubmitModalSkeleton.css';

const BulkSubmitModalSkeleton = ({ open, onClose }) => {
    return (
        <>
            <DialogContent className="dialogContent_bulkSubmit_skeleton">
                {/* Global Settings Skeleton */}
                <div className="globalSettings_bulkSubmit_skeleton">
                    <div className="globalSettingsRow_bulkSubmit_skeleton">
                        <div className="settingsField_bulkSubmit_skeleton">
                            <Skeleton
                                variant="text"
                                width={140}
                                height={20}
                                className="fieldLabel_skeleton"
                            />
                            <Skeleton
                                variant="rectangular"
                                width="100%"
                                height={40}
                                className="autocomplete_skeleton"
                            />
                        </div>
                        <div className="settingsField_bulkSubmit_skeleton">
                            <Skeleton
                                variant="text"
                                width={120}
                                height={20}
                                className="fieldLabel_skeleton"
                            />
                            <Skeleton
                                variant="rectangular"
                                width="100%"
                                height={40}
                                className="autocomplete_skeleton"
                            />
                        </div>
                    </div>
                    <Skeleton
                        variant="text"
                        width={150}
                        height={24}
                        className="tabContainerTitle_skeleton"
                    />
                    <div className="tabScrollContainer_bulkSubmit_skeleton">
                        {[...Array(3)].map((_, index) => (
                            <div key={index} className="candidateTab_bulkSubmit_skeleton">
                                <div className="tabContent_bulkSubmit_skeleton">
                                    <div className="candidateInfo_bulkSubmit_skeleton">
                                        <Skeleton variant="text" width={120} height={18} />
                                        <Skeleton variant="text" width={100} height={14} />
                                    </div>
                                    <Skeleton variant="circular" width={24} height={24} />
                                    <Skeleton variant="circular" width={24} height={24} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>


                {/* Candidate Details Container Skeleton */}
                <div className="candidateDetailsContainer_bulkSubmit_skeleton">
                    {/* Candidate Details Card Skeleton */}
                    <div className="candidateDetailsCard_bulkSubmit_skeleton">
                        <div className="candidateDetailsHeader_bulkSubmit_skeleton">
                            <Skeleton
                                variant="text"
                                width={140}
                                height={20}
                                className="candidateDetailsTitle_skeleton"
                            />
                        </div>
                        <div className="candidateDetailsContent_bulkSubmit_skeleton">
                            <Skeleton
                                variant="circular"
                                width={60}
                                height={60}
                                className="candidateAvatar_skeleton"
                            />
                            <div className="candidateInfo_bulkSubmit_skeleton">
                                <div className="candidateInfoRow_bulkSubmit_skeleton">
                                    <Skeleton variant="text" width={60} height={16} />
                                    <Skeleton variant="text" width={140} height={16} />
                                </div>
                                <div className="candidateInfoRow_bulkSubmit_skeleton">
                                    <Skeleton variant="text" width={50} height={16} />
                                    <Skeleton variant="text" width={180} height={16} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Content Wrapper Skeleton */}
                    <div className="configurableContentWrapper_bulkSubmit_skeleton">
                        <div className="configurableContent_bulkSubmit_skeleton">
                            {/* Select Stage Container Skeleton */}
                            <div className="selectStageContainer_bulkSubmit_skeleton">
                                <Skeleton
                                    variant="text"
                                    width={120}
                                    height={20}
                                    className="selectStageLabel_skeleton"
                                />
                                <div className="selectStageInputContainer_bulkSubmit_skeleton">
                                    <Skeleton
                                        variant="rectangular"
                                        width={250}
                                        height={40}
                                        className="autocomplete_skeleton"
                                    />
                                    <Skeleton
                                        variant="rectangular"
                                        width={180}
                                        height={40}
                                        className="editStagesButton_skeleton"
                                    />
                                </div>
                            </div>

                            {/* Detail Info Containers Skeleton */}
                            {[...Array(4)].map((_, index) => (
                                <div key={index} className="detailInfoContainer_bulkSubmit_skeleton">
                                    <div className="detailInfoContainerTitle_bulkSubmit_skeleton">
                                        <Skeleton variant="circular" width={20} height={20} />
                                        <Skeleton variant="text" width={200} height={20} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </DialogContent>
        </>
    );
};

export default BulkSubmitModalSkeleton;
